const { Record } = require('immutable');

const InitialState = Record({
  list: [],
});

export default InitialState;

